module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-02.53c0c86.webp";